module.exports = __webpack_public_path__ + "media/images/product_lines/i3-002ed731fd9c9f9677c43ba91057bcc6.svg";